import { useLingui } from '@lingui/react/macro';
import { selectPeriod } from 'modules/overlay-v2/store/time/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import UDText from 'ud-ui/components/text';
import { DivProps } from 'typings';
import { KitSwatch } from 'shared/components/kit';
import { KitElement } from 'shared/kit/kit-element';
import { AUTO_KIT_TYPE, resolveKitOutfit, TeamIndex } from 'shared/kit/resolve-team-color';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Fouls from './fouls';
import PlayersList from './players-list';
import Score from './score';
import { PanelItemWrapper } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps extends DivProps {
  teamIndex: number;
}

/** Свотч показывает три элемента формы всегда — без комплекта они рисуются белыми. */
const SWATCH_ELEMENTS = [KitElement.SHIRT, KitElement.SHORTS, KitElement.SOCKS];

function TeamPanel(props: IProps) {
  const { teamIndex, ...rest } = props;
  const { t } = useLingui();

  const { teams } = useGameInfo();
  const period = useSelector(selectPeriod);

  const team = useMemo(() => {
    if (teamIndex === 0) return teams?.first;
    if (teamIndex === 1) return teams?.second;
  }, [teamIndex, teams]);

  // Комплект по правилу `auto`: команда №1 играет в домашней форме, №2 — в гостевой.
  const kitOutfit = useMemo(() => resolveKitOutfit(team?.kits, AUTO_KIT_TYPE, teamIndex as TeamIndex), [team?.kits, teamIndex]);

  return (
    <PanelItemWrapper {...rest}>
      <div className={'flex-center w-full gap-2'}>
        <KitSwatch elements={SWATCH_ELEMENTS} elementStates={kitOutfit} />
        <UDText type={'headline'} color={theme.colors.Gray}>
          {team?.name ?? t`Неизвестная команда`}
        </UDText>
      </div>

      <div className={'flex flex-row flex-wrap gap-8'}>
        <div className={'flex grow flex-col'}>
          <Score className={'mt-2'} teamIndex={teamIndex} />
          <Fouls className={'mt-2'} teamIndex={teamIndex} period={period} />
        </div>
        <div>
          <PlayersList teamIndex={teamIndex} />
        </div>
      </div>
    </PanelItemWrapper>
  );
}

export default TeamPanel;
